import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../Images/LOGO 1.png'
import socialIcon1 from '../Images/1.png'
import socialIcon2 from '../Images/2.png'

import socialIcon4 from '../Images/4.png'
import socialIcon5 from '../Images/5.png'

function Footer() {
    return (
        <>

            <div>


                <footer
                    class="text-center text-lg-start text-white"
                    style={{ backgroundColor: "#1c2331" }}

                >

                    <section
                        class="d-flex justify-content-between p-4"
                        style={{ backgroundColor: "#288d99" }}

                    >

                        <div class="me-5">
                            <span style={{ fontFamily: "poppins" }}>Get connected with us on social networks:</span>
                        </div>



                        <div>
                            <a href="" class="text-white me-4">
                                <Link to="https://www.facebook.com/compliancekare/" target='_blank'>
                                    <img src={socialIcon1} alt="Social_icon" style={{ width: "40px", cursor: "pointer" }} title='facebook' />
                                </Link>
                            </a>
                            <a href="" class="text-white me-4">
                                <Link to="https://www.instagram.com/compliancekare/" target='_blank'>
                                    <img src={socialIcon5} alt="Social_icon" style={{ width: "40px", cursor: "pointer" }} title='Instagram' />
                                </Link>
                            </a>
                            <a href="" class="text-white me-4">
                                <Link to="https://twitter.com/compliancekare/" target='_blank'>
                                    <img src={socialIcon4} alt="Social_icon" style={{ width: "40px", cursor: "pointer" }} title='twitter' />
                                </Link>
                            </a>
                            <a href="" class="text-white me-4">
                                <Link to="https://www.facebook.com/compliancekare/" target='_blank'>
                                    <img src={socialIcon2} alt="Social_icon" style={{ width: "40px", cursor: "pointer" }} title='youtube' />
                                </Link>
                            </a>

                        </div>

                    </section>



                    <section class="">
                        <div class="container text-center text-md-start mt-5">

                            <div class="row mt-3">





                                <div class="col-md-2 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">Company</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />

                                    <div>
                                        <Link to="/">
                                        <img src={Logo} alt="logo" style={{ border: "1px solid #89c764", padding: "1px" }} />
                                        </Link>
                                    </div>

                                    <p  style={{textAlign:"justify"}}>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </p>

                                </div>
                                <div class="col-md-2 col-lg-2 col-xl-2  " >

                                    <h6 class="text-uppercase fw-bold">NEW BUSINESS</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <Link to="/Propitorship" class="text-white">Proprietorship</Link>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">LLP registration</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Partnership Firm</a>
                                    </p>


                                    <p>
                                        <a href="#!" class="text-white">Limited Company</a>
                                    </p>

                                    <p>
                                        <a href="#!" class="text-white">one Person Company</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Private Limited Company</a>
                                    </p>
                                </div>



                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold"></h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">Trust</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Society</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Nidhi Company</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">NBFC Registration</a>
                                    </p>

                                    <p>
                                        <a href="#!" class="text-white">Producer company</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Section 8 company</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Core Investment company</a>
                                    </p>

                                </div>

                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">INCOME TAX</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">Pan Application</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Link Adhar with PAN</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">TAN application</a>
                                    </p>


                                    <p>
                                        <a href="#!" class="text-white">Income Tax Return</a>
                                    </p>

                                    <p>
                                        <a href="#!" class="text-white">TDS return</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">TDS on property</a>
                                    </p>
                                </div>
                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold"></h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">TCS return</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Income Tax refund</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Income Tax Notice</a>
                                    </p>


                                    <p>
                                        <a href="#!" class="text-white">Registration 12AA/80G</a>
                                    </p>

                                    <p>
                                        <a href="#!" class="text-white">Income Tax Demand</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Advance Tax calculation</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Income Tax Planning</a>
                                    </p>
                                </div>
                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">GST</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">GST registration</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">GST return</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">GST refund</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">GST Notice</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">GST Demand</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">GST registration surrender</a>
                                    </p>
                                </div>





                            </div>

                        </div>
                    </section>
                    <section class="">
                        <div class="container text-center text-md-start mt-5">

                            <div class="row mt-3">





                                <div class="col-md-2 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">Quick Links</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">About</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Contact</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Blog</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">FAQ</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Privacy Policy</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Terms & Conditions</a>
                                    </p>
                                </div>
                                <div class="col-md-2 col-lg-2 col-xl-2  " >

                                    <h6 class="text-uppercase fw-bold">Compliance</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">MSME Registration</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">FSSAI Registration</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Trademark Registration</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">ISO certification</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Company law compliance</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">LLP law compliance</a>
                                    </p>
                                </div>



                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">Loans</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">Project report</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Business planning</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Business loan</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">CC or overdraf</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Personal loan</a>
                                    </p>
                                </div>

                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold"></h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">inter corporate loans</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Home Loans</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Education Loan</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Loan against property</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Vehicle Loan</a>
                                    </p>
                                </div>
                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold">Investments</h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">Mutual fund</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Demat account</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Investment in real estate</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Fixed Deposits</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Bonds</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">life Insurance</a>
                                    </p>
                                </div>
                                <div class="col-md-3 col-lg-2 col-xl-2 ">

                                    <h6 class="text-uppercase fw-bold"></h6>
                                    <hr
                                        class="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#!" class="text-white">Term Insurance</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">General Insurance</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Health Insurance</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Annuity Plan</a>
                                    </p>
                                    <p>
                                        <a href="#!" class="text-white">Retirement plans</a>
                                    </p>
                                </div>





                            </div>

                        </div>
                    </section>




                    <div
                        class="text-center p-3"
                        style={{ backgroundColor: "#89c764" }}

                    >
                        © 2023 Copyright:
                        <a class="text-white" href="https://compliancekare.com/"
                        >Compliancekare.com</a
                        >
                    </div>

                </footer>


            </div>

        </>
    )
}

export default Footer